import { createRouter, createWebHistory } from "vue-router";
import {
  breadCrumb,
  closeAllPanels,
  pageTitle,
  panels,
  setCaption,
} from "@/layouts/layouts";

import Bus from "@/core/bus";
import stateStore from "@/store";

const routes = [
  {
    path: "",
    component: () => import("@/layouts/Panels.vue"),
    children: [
      {
        path: "",
        component: () => import("@/views/main/index.vue"),
      },
      {
        path: "/ward-occupancy",
        component: () => import("@/views/ward-occupancy/index.vue"),
      },
      {
        path: "/occupancy-plan",
        component: () => import("@/views/occupancy-plan/index.vue"),
      },
      {
        path: "/webinars",
        component: () => import("@/tables/webinars/List/index.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/dbform",
        component: () => import("@/views/dbform/index.vue"),
        meta: {
          title: "DB-form",
        },
      },
      {
        path: "/select",
        component: () => import("@/views/Testings/Select.vue"),
        meta: {
          title: "Компонент выбора",
        },
      },
      {
        path: "/comments",
        component: () => import("@/views/Testings/Comments.vue"),
        meta: {
          title: "Комментарии",
        },
      },
      {
        path: "/printbarcodes",
        component: () => import("@/views/PrintBarcodes.vue"),
        meta: {
          title: "Печать штрих-кодов",
        },
      },
      {
        path: "/demo1",
        component: () => import("@/views/Testings/Demo1.vue"),
        meta: {
          title: "Demo 1",
        },
      },
      {
        path: "/development",
        component: () => import("@/views/Testings/Development.vue"),
        meta: {
          title: "Development",
        },
      },
      {
        path: "/css_test",
        component: () => import("@/views/Testings/css.vue"),
        meta: {
          title: "CSS",
        },
      },
      {
        path: "/reports",
        component: () => import("@/reports/index.vue"),
      },
      {
        path: "/publications/:guid",
        component: () => import("@/views/Publication.vue"),
        meta: {
          title: "",
        },
      },
      {
        path: "/help",
        component: () => import("@/views/Help.vue"),
        meta: {
          title: "Помощь",
        },
      },
      {
        path: "/inspection_patients",
        component: () => import("@/views/inspection_patients/index.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/inspection_med_histor",
        component: () => import("@/views/inspection_med_histor/index.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/patients",
        component: () => import("@/tables/patients/forms/List.vue"),
        meta: {
          roles: ["admin", "social_worker"],
        },
      },
      {
        path: "/signals",
        component: () => import("@/components/Signals/List.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/patients/:id",
        component: () => import("@/tables/patients/forms/List.vue"),
        meta: {
          roles: ["admin", "social_worker"],
        },
      },
      {
        path: "/extract_list",
        component: () => import("@/tables/extract_list/forms/List.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/outpatient_appointment",
        component: () =>
          import("@/tables/outpatient_appointment/forms/List.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/patients_cards",
        component: () => import("@/tables/patients_cards/List/index.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/social_service",
        component: () => import("@/tables/social_service/List/index.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/chatgpt",
        component: () => import("@/tables/chatgpt/index.vue"),
        meta: {
          roles: ["admin"],
        },
      },
      {
        path: "/virtual_doctor",
        component: () => import("@/tables/virtual_doctor/index.vue"),
        meta: {
          roles: ["admin"],
        },
      },
      {
        path: "/work_time",
        component: () => import("@/tables/work_time/index.vue"),
        meta: {
          roles: ["admin", "medical_doctor", "social_worker"],
        },
      },
      {
        path: "/medical_service",
        component: () => import("@/tables/medical_service/index.vue"),
        meta: {
          roles: ["admin", "medical_doctor", "social_worker"],
        },
      },
      {
        path: "/social_service_info",
        component: () => import("@/tables/social_service_info/index.vue"),
        meta: {
          roles: ["admin", "social_worker"],
        },
      },
      {
        path: "/appointment_research",
        component: () => import("@/tables/appointment_research/forms/List.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/appointment_procedure",
        component: () =>
          import("@/tables/appointment_procedure/forms/List.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/patients_cards/:id",
        component: () => import("@/tables/patients_cards/List/index.vue"),
        meta: {
          roles: ["admin", "social_worker", "medical_doctor"],
        },
      },
      {
        path: "/tables",
        component: () => import("@/views/ViewTables.vue"),
        meta: {
          title: "Список таблиц",
          roles: ["admin", "market_user"],
        },
      },
      {
        path: "/tables/:table",
        component: () => import("@/tables/List.vue"),
        meta: {
          title: "Таблица",
        },
      },
      {
        path: "/about",
        component: () => import("@/views/About.vue"),
        meta: {
          title: "О портале",
        },
      },
      {
        path: "/messages",
        component: () => import("@/views/messages.vue"),
        meta: {
          title: "Сообщения",
        },
      },
      {
        path: "/icons",
        component: () => import("@/views/Icons.vue"),
        meta: {
          title: "Иконки - e-med",
        },
      },
    ],
  },
  {
    path: "/profile",
    component: () => import("@/views/profile/index.vue"),
    meta: {
      title: "Профиль",
      breadCrumb: [
        {
          route: "/profile",
          icon: "icon icon-user",
          caption: "Профиль",
        },
      ],
    },
    children: [
      {
        path: "",
        component: () => import("@/views/profile/page.vue"),
        meta: {
          title: "Основные данные",
          icon: "icon icon-more-horizontal",
          breadCrumb: [
            {
              route: "/profile",
              icon: "icon icon-user",
              caption: "Профиль",
            },
            {
              icon: "icon icon-book-open",
              caption: "Основные данные",
            },
          ],
        },
      },
      {
        path: "page",
        component: () => import("@/views/profile/page.vue"),
        meta: {
          title: "Основные данные",
          icon: "icon icon-book-open",
          breadCrumb: [
            {
              route: "/profile",
              icon: "icon icon-user",
              caption: "Профиль",
            },
            {
              icon: "icon icon-book-open",
              caption: "Основные данные",
            },
          ],
        },
      },
      {
        path: "equipment",
        component: () => import("@/views/profile/equipment.vue"),
        meta: {
          title: "Оборудование",
          icon: "icon icon-printer",
          breadCrumb: [
            {
              route: "/profile",
              icon: "icon icon-user",
              caption: "Профиль",
            },
            {
              icon: "icon icon-printer",
              caption: "Оборудование",
            },
          ],
        },
      },
    ],
  },
  {
    path: "/user/:guid",
    component: () => import("@/views/UserProfile/index.vue"),
    meta: {
      title: "Профиль",
    },
    children: [
      {
        path: "",
        component: () => import("@/views/UserProfile/AboutUser.vue"),
        meta: {
          title: "О пользователе",
          icon: "icon-user",
        },
      },
      {
        path: "aboutuser",
        component: () => import("@/views/UserProfile/AboutUser.vue"),
        meta: {
          title: "О пользователе",
          icon: "icon-user",
        },
      },
    ],
  },
  {
    path: "/login",
    component: () => import("@/views/auth/Login.vue"),
    meta: {
      layout: "empty-layout",
    },
  },
  {
    path: "/404",
    component: () => import("@/views/Page404.vue"),
  },
  {
    path: "/:pathMatch(.*)",
    component: () => import("@/views/Page404.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export const openRoute = (path: string) => {
  const currentRoute = router.currentRoute.value.path
    .split("/")
    .filter((el) => el);
  const newRoute = path.split("/").filter((el) => el);

  if (
    currentRoute.length > 0 &&
    newRoute.length > 0 &&
    currentRoute[0] == newRoute[0]
  ) {
    router.replace(path);
  }
};

Bus.$on("ws-open-document", (data: any) => {
  switch (data.type_document) {
    default:
      // console.log(data);

      // router.push(`pgi_research/${data.id}`);

      break;
  }
});

router.beforeEach(async (to, from) => {
  //Прописывать в роутах роли и проверять доступ при переходах
  if (to.fullPath != from.fullPath) {
    for (const panel of panels.value) {
      if (panel.onBeforeClose) {
        if (!(await panel.onBeforeClose())) return false;
      }
    }

    closeAllPanels();

    setCaption("");
  }

  if (to.path === "/login") {
    return true;
  }

  //Получаем статус пользователя
  // Если пользователь уже есть в store, используем его (после логина)
  let user: any = stateStore.state.user;
  if (!user || !user.id) {
    // Если пользователя нет в store, проверяем статус через API
    user = await stateStore.dispatch("status");
  }

  // Если пользователь не авторизован (нет id), перенаправляем на логин
  if (!user.id) {
    return { path: "/login" };
  }

  //Если в метаданных прописаны роли, то производим проверку на доступ, если не указана ни одна роль - доступ запрещен
  if (to.meta.roles) {
    const roles: any = to.meta.roles;

    for (const routeRole of roles) {
      if (user.roles.includes(routeRole)) return true;
    }

    return { path: "/404" };
  } else {
    return true;
  }
});

router.afterEach((to) => {
  breadCrumb.value = to.meta.breadCrumb ? to.meta.breadCrumb : [];

  pageTitle.value = to.meta.title ? to.meta.title : null;
});

export default router;
